import React from 'react';
import styled from "styled-components/macro";

export interface PropsI {
  border?: boolean,
  scrollX?: boolean,
  scrollY?: boolean
}

// @ts-ignore
export const ScrollBox = (props: Props) => <Panel {...props} />;

const overflow = (enabled) => {
  if (enabled === true) {
    return 'scroll'
  } else if (enabled === false) {
    return 'hidden'
  } else {
    return 'auto';
  }
}

export const Panel = styled.div<{ border: false, scrollX: boolean, scrollY: boolean }>`
  overflow-x: ${(p) => overflow(p.scrollX)};
  ${(p) => p.border && `border: 1px solid #2D617A`};
  overflow-y: ${(p) => overflow(p.scrollY)};
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  ::-webkit-scrollbar-track { 
    background: ${(p) => p.theme.palette.backgroundSecondary};
  }
  ::-webkit-scrollbar-thumb {
    background: ${(p) => p.theme.palette.accentPrimary};
    border-radius: 5px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${(p) => p.theme.palette.accentSecondary};
  }
  ::-webkit-scrollbar-corner {
    background: ${(p) => p.theme.palette.backgroundSecondary};
  }
`;
